import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useLmnDsTheme } from "../../../index.js";
export var SliderSpinner = function SliderSpinner(props) {
  var theme = useLmnDsTheme();
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99986 0.571411C12.1025 0.571411 15.4284 3.8973 15.4284 7.99998C15.4284 12.1027 12.1025 15.4286 7.99986 15.4286C7.57907 15.4286 7.23796 15.0874 7.23796 14.6666C7.23796 14.2459 7.57907 13.9047 7.99986 13.9047C11.261 13.9047 13.9046 11.2611 13.9046 7.99998C13.9046 4.73887 11.261 2.09522 7.99986 2.09522C4.73875 2.09522 2.0951 4.73887 2.0951 7.99998C2.0951 8.42077 1.75398 8.76189 1.33319 8.76189C0.912405 8.76189 0.571289 8.42077 0.571289 7.99998C0.571289 3.8973 3.89717 0.571411 7.99986 0.571411Z",
    fill: theme.kallisto.color.border.interactive.borderPrimaryDefault
  }));
};